import { fromJS, is } from 'immutable';
export const LIST_EVENT_TRIGGER_TYPES = ['ADDED_TO_LIST_TRIGGER', 'REMOVED_FROM_LIST_TRIGGER'];

// Grabs the list triggers of type ADDED_TO_LIST and REMOVED_FROM_LIST and maps them to individual new lists for the FE to digest
export const getListEventAssociatedLists = flow => {
  return flow.associatedLists.map(list => list.listTypes.filter(listType => LIST_EVENT_TRIGGER_TYPES.includes(listType)).map(listType => Object.assign({}, list, {
    listTypes: [listType]
  }))).flat();
};
export const getEnrollmentList = flow => {
  return flow.associatedLists.find(list => list.listTypes.includes('ENROLLMENT_LIST'));
};
export function areFilterBranchesEqual(filterBranchA, filterBranchB) {
  if (!filterBranchA || !filterBranchB) {
    return !!filterBranchA === !!filterBranchB;
  }
  const immutableFilterBranchA = fromJS(filterBranchA);
  const immutableFilterBranchB = fromJS(filterBranchB);
  return is(immutableFilterBranchA, immutableFilterBranchB);
}